export const APP_NAME = "AGNT";
export const TOKEN_NAME = "ATTS";

export const TOKEN_MIN_AMOUNT = 20;
export const TOKEN_MAX_AMOUNT = 50000;
